module.exports = __webpack_public_path__ + "static/media/blumira-logo-white.92ce7f4d.svg";